import React from 'react';
import { Box, BoxProps } from '@mui/material';

export interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string;
  alt: string;
  containerProps?: BoxProps;
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';
  objectPosition?: string;
  imageStyle?: React.CSSProperties;
}

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  containerProps,
  objectFit = 'contain',
  objectPosition = 'center',
  imageStyle,
  ...imgProps
}) => {
  return (
    <Box
      {...containerProps}
      sx={{
        display: 'inline-block',
        ...containerProps?.sx,
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit,
          objectPosition,
          display: 'block',
          ...imageStyle,
        }}
        {...imgProps}
      />
    </Box>
  );
};

export default Image;
